import request from 'superagent';
import config from '../config';

const data = (query) => {
  return new Promise((resolve, reject) => {
    request
    .get(`${config.serverUrl}/page`)
    .set('Content-Type', 'application/json')
    .end(function(err, resp) {
      if (err) {
        return reject(err);
      }

      resp.body = resp.body.map(page => {
        if (page.sliderImages && page.sliderImages.items) {
          page.sliderImages = page.sliderImages.items;
        }

        if (page.menuItems && page.menuItems.items) {
          page.menuItems = page.menuItems.items;
        }

        if (page.articles) {
          page.articles = page.articles.split(',');
        }

        return page;
      });

      return resolve(Object.assign({}, {
        pages: resp.body,
        global: {
          logoUrl: '/assets/images/logo_aeroport_small.png'
        }
      }));
    });
  });
};

module.exports = {
  data() {
    return data();
  }
};



// WEBPACK FOOTER //
// ./src/services/websiteSettings.js